import(/* webpackMode: "eager", webpackExports: ["RootProviders"] */ "/builds/frontend-eva/jti-next/apps/jti-next/src/app/[locale]/_internal/RootProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Link"] */ "/builds/frontend-eva/jti-next/apps/jti-next/src/libs/i18n/Link.tsx");
;
import(/* webpackMode: "eager" */ "/builds/frontend-eva/jti-next/apps/jti-next/src/styles/globals.scss");
;
import(/* webpackMode: "eager" */ "/builds/frontend-eva/jti-next/apps/jti-next/src/styles/_brand-tokens.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Blocks","BuilderContext","Button","Columns","Content","Fragment","Image","Section","Symbol","Text","Video"] */ "/builds/frontend-eva/jti-next/node_modules/@builder.io/sdk-react/lib/node/blocks-exports.mjs");
;
import(/* webpackMode: "eager" */ "/builds/frontend-eva/jti-next/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/builds/frontend-eva/jti-next/packages/common/dist/esm/providers/contexts.js");
;
import(/* webpackMode: "eager" */ "/builds/frontend-eva/jti-next/packages/common/dist/esm/providers/languages.js");
;
import(/* webpackMode: "eager" */ "/builds/frontend-eva/jti-next/packages/common/dist/esm/translation/TranslationsContext.js");
;
import(/* webpackMode: "eager" */ "/builds/frontend-eva/jti-next/packages/des-styles/base.scss");
